var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgApps = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.5V7.5C8 7.77614 7.77614 8 7.5 8H4.5C4.22386 8 4 7.77614 4 7.5V4.5C4 4.22386 4.22386 4 4.5 4H7.5C7.77614 4 8 4.22386 8 4.5ZM13.5 4H10.5C10.2239 4 10 4.22386 10 4.5V7.5C10 7.77614 10.2239 8 10.5 8H13.5C13.7761 8 14 7.77614 14 7.5V4.5C14 4.22386 13.7761 4 13.5 4ZM16.5 4H19.5C19.7761 4 20 4.22386 20 4.5V7.5C20 7.77614 19.7761 8 19.5 8H16.5C16.2239 8 16 7.77614 16 7.5V4.5C16 4.22386 16.2239 4 16.5 4ZM7.5 10H4.5C4.22386 10 4 10.2239 4 10.5V13.5C4 13.7761 4.22386 14 4.5 14H7.5C7.77614 14 8 13.7761 8 13.5V10.5C8 10.2239 7.77614 10 7.5 10ZM10.5 10H13.5C13.7761 10 14 10.2239 14 10.5V13.5C14 13.7761 13.7761 14 13.5 14H10.5C10.2239 14 10 13.7761 10 13.5V10.5C10 10.2239 10.2239 10 10.5 10ZM19.5 10H16.5C16.2239 10 16 10.2239 16 10.5V13.5C16 13.7761 16.2239 14 16.5 14H19.5C19.7761 14 20 13.7761 20 13.5V10.5C20 10.2239 19.7761 10 19.5 10ZM4.5 16H7.5C7.77614 16 8 16.2239 8 16.5V19.5C8 19.7761 7.77614 20 7.5 20H4.5C4.22386 20 4 19.7761 4 19.5V16.5C4 16.2239 4.22386 16 4.5 16ZM13.5 16H10.5C10.2239 16 10 16.2239 10 16.5V19.5C10 19.7761 10.2239 20 10.5 20H13.5C13.7761 20 14 19.7761 14 19.5V16.5C14 16.2239 13.7761 16 13.5 16ZM16.5 16H19.5C19.7761 16 20 16.2239 20 16.5V19.5C20 19.7761 19.7761 20 19.5 20H16.5C16.2239 20 16 19.7761 16 19.5V16.5C16 16.2239 16.2239 16 16.5 16Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgApps, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/apps.eb9c9f07.svg";
export { ForwardRef as ReactComponent };